
import React from 'react';
import ReactMarkdown from 'react-markdown';

interface PositSummaryFullDetailsProps {
  summary: string | null;
  searchTerm?: string;
  isPremium?: boolean;
}

const PositSummaryFullDetails = ({ 
  summary, 
  searchTerm = "", 
  isPremium = false 
}: PositSummaryFullDetailsProps) => {
  if (!summary) {
    return <p className="text-muted-foreground">No detailed summary available.</p>;
  }

  // If no search term or not premium, just render the markdown
  if (!isPremium || !searchTerm) {
    return (
      <div className="prose max-w-none dark:prose-invert">
        <ReactMarkdown>{summary}</ReactMarkdown>
      </div>
    );
  }

  // For searching, process the text before applying markdown
  const highlightMatches = (text: string) => {
    if (!searchTerm) return text;
    
    const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const parts = text.split(new RegExp(`(${escapedSearchTerm})`, 'gi'));
    
    return parts.map((part, i) => {
      if (part.toLowerCase() === searchTerm.toLowerCase()) {
        return `<mark class="bg-primary/20 text-foreground px-1 rounded">${part}</mark>`;
      }
      return part;
    }).join('');
  };

  const highlightedContent = highlightMatches(summary);

  return (
    <div className="prose max-w-none dark:prose-invert">
      <ReactMarkdown>{highlightedContent}</ReactMarkdown>
    </div>
  );
};

export default PositSummaryFullDetails;
